export const navLink = "robots_history";
export const name = "Історія роботів";
